<div
  *appHasPermission="{ resource: Resources.Merchants, scope: Scopes.Read }"
  class="merchant-details-container"
  [ngClass]="{
    'sidebar-open': sideComponentOpen(),
    'assets-drawer-open': assetsDrawerOpen,
    'withdraw-tab-height': activeTab === 'Withdraw',
    'deposit-tab-height': activeTab === 'Deposit',
  }"
  >
  @if (isSettlementApp) {
    <a routerLink="/merchants" class="back-link"> Back to merchants </a>
  }

  <app-financial-summary-header
    layout="dashboard"
    balanceLabel="Merchant balance"
    [entityName]="merchantName"
    [entityData]="entityData"
    [logoBase64]="logoBase64"
    [isLoading]="isLoadingMerchant"
    [balanceError]="balanceError"
    [showAssetsButton]="showAssetsButton"
    [assetsOpen]="assetsDrawerOpen"
    (toggleAssets)="toggleAssetsDrawer()"
    />

  <div class="tabs" appTabStrip="Merchant sections">
    <button
      *appHasPermission="{ resource: Resources.Merchants, scope: Scopes.Read }"
      class="tab"
      [ngClass]="{ active: activeTab === 'Balance' }"
      (click)="selectTab('Balance')"
      >
      <mat-icon class="tab-icon">account_balance_wallet</mat-icon><span class="tab-text" data-text="Balance">Balance</span>
    </button>

    <button
      *appHasPermission="{ resource: Resources.MerchantTransactions, scope: Scopes.Read }"
      class="tab"
      [ngClass]="{ active: activeTab === 'Transaction History' }"
      (click)="selectTab('Transaction History')"
      >
      <mat-icon class="tab-icon">access_time_filled</mat-icon
        ><span class="tab-text" data-text="Transaction History">Transaction History</span>
      </button>

      <button
        *appHasPermission="{ resource: Resources.MerchantTransactions, scope: Scopes.Create }"
        class="tab"
        [ngClass]="{ active: activeTab === 'Deposit' }"
        (click)="selectTab('Deposit')"
        >
        <img class="custom-tab-icon" src="shared-assets/icons/Deposit.png" alt="" /><span
        class="tab-text"
        data-text="Deposit"
        >Deposit</span
        >
      </button>

      <button
        *appHasPermission="{ resource: Resources.MerchantTransactions, scope: Scopes.Create }"
        class="tab"
        [ngClass]="{ active: activeTab === 'Withdraw' }"
        (click)="selectTab('Withdraw')"
        >
        <img class="custom-tab-icon" src="shared-assets/icons/withdrawal.svg" alt="" /><span
        class="tab-text"
        data-text="Withdraw"
        >Withdraw</span
        >
      </button>

      @if (isSettlementApp) {
        <button
          *appHasPermission="{ resource: Resources.MerchantWallets, scope: Scopes.Read }"
          class="tab"
          [ngClass]="{ active: activeTab === 'Wallet' }"
          (click)="selectTab('Wallet')"
          >
          <mat-icon class="tab-icon">wallet</mat-icon><span class="tab-text" data-text="Wallet">Wallet</span>
        </button>
      }

      <button
        *appHasPermission="{ resource: Resources.MerchantWhitelistedWallets, scope: Scopes.Read }"
        class="tab"
        [ngClass]="{ active: activeTab === 'Whitelisted Wallets' }"
        (click)="selectTab('Whitelisted Wallets')"
        >
        <mat-icon class="tab-icon">verified_user</mat-icon
          ><span class="tab-text" data-text="Whitelisted Wallets">Whitelisted Wallets</span>
        </button>

        @if (isSettlementApp) {
          <button
            *appHasPermission="{ resource: Resources.Merchants, scope: Scopes.Update }"
            class="tab"
            [ngClass]="{ active: activeTab === 'Edit Merchant' }"
            (click)="selectTab('Edit Merchant')"
            >
            <mat-icon class="tab-icon">edit</mat-icon><span class="tab-text" data-text="Edit Merchant"> Edit Merchant</span>
          </button>
        }
        @if (!isSettlementApp) {
          <button
            *appHasPermission="{ resource: Resources.MerchantWallets, scope: Scopes.Access }"
            class="tab"
            [ngClass]="{ active: activeTab === 'Wallet Check' }"
            (click)="selectTab('Wallet Check')"
            >
            <mat-icon class="tab-icon">visibility</mat-icon
              ><span class="tab-text" data-text="Wallet Check">Wallet Check</span>
            </button>
          }
        </div>

        <!-- Settlement portal: tab content waits until the merchant has loaded and access to it is confirmed -->
        @if (isSettlementApp && !hasMerchantAccess) {
          @if (isLoadingMerchant) {
            <div class="tab-content merchant-content-loading" role="status" aria-live="polite">
              <app-loading-spinner size="large" label="Loading merchant..." />
            </div>
          }
        } @else {
          @if (activeTab === 'Balance') {
            <div class="tab-content" *appHasPermission="{ resource: Resources.Merchants, scope: Scopes.Read }">
              <app-balance-breakdown
                [walletBalances]="entityData.walletBalances ?? null"
                [isLoading]="isLoadingMerchant"
                [error]="balanceError"
                />
            </div>
          }

          @if (activeTab === 'Transaction History') {
            <div class="tab-content" *appHasPermission="{ resource: Resources.MerchantTransactions, scope: Scopes.Read }">
              <app-merchant-transaction-history [initialSearch]="transactionHistorySearch" />
            </div>
          }

          @if (activeTab === 'Deposit') {
            <div
              class="tab-content tab-content-fill"
              *appHasPermission="{ resource: Resources.MerchantTransactions, scope: Scopes.Create }"
              >
              <app-merchant-deposit
                [wallets]="merchantWallets"
                [merchant]="merchant"
                [isLoading]="isLoadingWallets"
                [error]="walletsError"
                />
            </div>
          }

          @if (activeTab === 'Withdraw') {
            <div
              class="tab-content tab-content-fill"
              *appHasPermission="{ resource: Resources.MerchantTransactions, scope: Scopes.Create }"
              >
              <app-merchant-withdraw
                [totalBalance]="entityData.walletBalances!.currencyBalances"
                [wallets]="merchantWallets"
                [isLoading]="isLoadingWallets"
                [error]="walletsError"
                [isMultiRiskPaymentsEnabled]="merchant.isMultiRiskPaymentsEnabled"
                [riskGroups]="merchant.riskGroups || []"
                />
            </div>
          }

          @if (activeTab === 'Wallet') {
            <div class="tab-content" *appHasPermission="{ resource: Resources.MerchantWallets, scope: Scopes.Read }">
              <app-merchant-wallet-management
                [merchantId]="merchantId || ''"
                [wallets]="merchantWallets"
                [initialApiWallets]="merchantApiWallets"
                [totalWallets]="totalWallets"
                [isLoadingInitialWallets]="isLoadingWallets"
                (walletCreated)="onWalletCreated($event)"
                [isDisableFilters]="isDisableFilters"
                [isFirstLoad]="isFirstLoad"
                [hasMoreWallets]="hasMoreWallets"
                [hasMoreApiWallets]="hasMoreApiWallets"
                [oneTimeWalletsCount]="oneTimeWalletsCount"
                [apiWalletsCount]="apiWalletsCount"
                [riskGroups]="merchant.riskGroups || []"
                />
            </div>
          }

          @if (activeTab === 'Whitelisted Wallets') {
            <div
              class="tab-content"
              *appHasPermission="{ resource: Resources.MerchantWhitelistedWallets, scope: Scopes.Read }"
              >
              <app-merchant-whitelisted-wallets [merchantId]="merchantId" />
            </div>
          }

          @if (activeTab === 'Edit Merchant') {
            <div class="tab-content" *appHasPermission="{ resource: Resources.Merchants, scope: Scopes.Update }">
              <app-merchant-edit [merchant]="merchant" />
            </div>
          }

          @if (activeTab === 'Wallet Check') {
            <div class="tab-content" *appHasPermission="{ resource: Resources.MerchantWallets, scope: Scopes.Read }">
              <olv-wallet-check [merchantId]="merchantId || ''" />
            </div>
          }
        }
      </div>

      @if (assetsDrawerOpen) {
        <app-asset-balance-drawer
          [walletBalances]="entityData.walletBalances ?? null"
          [isLoading]="isLoadingMerchant"
          [error]="balanceError"
          (closed)="assetsDrawerOpen = false"
          />
      }
